import { useState } from 'react';
import ContractChartWidget from '../components/ContractChartWidget';
import RSIVWAPStudyTable from '../components/RSIVWAPStudyTable';
import Coil30StudyTable from '../components/Coil30StudyTable';

export default function BotTest() {
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedCoil, setSelectedCoil] = useState(null);

  return (
    <div>
      {/* ── RSI(7)+VWAP 5-minute study ─────────────────────────────────────
          RTH is forced because the signal's VWAP is computed on RTH-only
          bars; on GLOBAL the chart's VWAP also accumulates overnight bars
          and reads ~$0.80 too high on 0DTE contracts. */}
      <ContractChartWidget
        contract={selectedContract}
        forceTf="5m"
        forceSession="regular"
        focus={selectedContract ? { date: selectedContract.date, time: selectedContract.entryTime } : null}
      />
      <RSIVWAPStudyTable onSelect={setSelectedContract} />

      {/* ── 30-minute coil study ───────────────────────────────────────────
          Its own chart with the strategy's own indicator settings (RSI 14/
          SMA 14 bands 70/50/30, MACD 12/26/9) and the full-hours session,
          matching the user's reference TradingView chart. */}
      <ContractChartWidget
        contract={selectedCoil}
        forceTf="30m"
        forceSession="full"
        indicators={{ rsiPeriod: 14, rsiSmooth: 14, rsiBands: [70, 50, 30], macd: [12, 26, 9] }}
        focus={selectedCoil ? { date: selectedCoil.date, time: selectedCoil.entryTime } : null}
      />
      <Coil30StudyTable onSelect={setSelectedCoil} />
    </div>
  );
}
